import { Duration } from 'moment';
import { createSelector, ParametricSelector, Selector } from 'reselect';

import { Bank } from '@/api/dictionary';
import { RootState } from '@/model/types';

import { InvoiceDetails, InvoiceDetailsLoadError, InvoiceProcessingStatus, Limits } from './types';

export const makeSelectInitialized = (): Selector<RootState, boolean> =>
  createSelector(
    (state: RootState) => state.invoice.initialized,
    (state) => state,
  );

export const makeSelectLimits = (): Selector<RootState, Limits | undefined> =>
  createSelector(
    (state: RootState) => state.invoice.limits,
    (state) => state,
  );

export const makeSelectBanks = (): Selector<RootState, Bank[]> =>
  createSelector(
    (state: RootState) => state.invoice.banks,
    (state) => state,
  );

export const makeSelectBank = (): ParametricSelector<RootState, string, Bank | undefined> =>
  createSelector(
    (state: RootState) => state.invoice.banks,
    (_: RootState, id: string) => id,
    (state: Bank[], id) => state.filter(({ id: saved }) => saved === id)[0],
  );

export const makeSelectDetails = (): Selector<
  RootState,
  { value?: InvoiceDetails; error?: InvoiceDetailsLoadError } | undefined
> =>
  createSelector(
    (state: RootState) => state.invoice.details,
    (state) => state,
  );

export const makeSelectValidPeriod = (): Selector<RootState, Duration | undefined> =>
  createSelector(
    (state: RootState) => state.invoice.validPeriod,
    (state) => state,
  );

export const makeSelectProcessingStatus = (): Selector<RootState, InvoiceProcessingStatus | undefined> =>
  createSelector(
    (state: RootState) => state.invoice.processingStatus,
    (state) => state,
  );

export default {
  makeSelectInitialized,
  makeSelectBanks,
  makeSelectDetails,
  makeSelectLimits,
  makeSelectProcessingStatus,
  makeSelectValidPeriod,
};
